<template>
  <div class="home">
    <div v-if="loadingCodeInfo">Laddar lite information...</div>
    <div v-else>
      <div class="title">
        <h3>Återställ lösenord</h3>
      </div>

      <div v-if="!codeSuccess">
        <p>Det ser ut som om du har angivit en återställningskod som är felaktig eller som har gått ut. Prova att återställa ditt lösenord igen.</p>
        <p>Om ovanstående inte fungerar, kontakta support@nexa.se</p>
      </div>
      <div v-else>
        <div v-if="!success">
          <div style="text-align:center;padding:20px;">
            <h5 style="margin-bottom:10px;">{{ email.length ? email : '-' }}</h5>
            
            <div style="font-size:13px;">
              <div v-if="!error.length">Skriv in ditt nya lösenord nedan, det måste vara minst 6 tecken långt. Använd helst stora och små bokstäver samt specialtecken.</div>
              <div v-else>
                <div style="color:#e74c3c">{{ (error in errorMessages ? errorMessages[error] : error) }}</div>
              </div>
            </div>
          </div>
          
          <div style="padding:20px;padding-top:5px;">
            <div><input class="input" type="password" placeholder="Lösenord" v-model="password"></div>
            <div><input class="input" type="password" placeholder="Bekräfta lösenord" v-model="password2"></div>
            <div style="text-align:center;"><button class="submit" :disabled="!ok" @click="restore">Uppdatera lösenord</button></div>
          </div>
        </div>
        <div v-else>
          <div v-if="success">
            Ditt lösenord har återställts!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.home {
  margin:12px;
}
</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {},
  created () {

  },
  mounted () {
    fetch(`https://api.systemnexa2.se/1/account/password/restore?code=${this.$route.params.code}`)
    .then(res => res.json())
    .then(json => {
      if (json.success) {
        this.email = json.data.email
      }

      this.codeSuccess = json.success
      this.loadingCodeInfo = false
    })
  },
  data: () => ({
    email: '',
    password: '',
    password2: '',
    restored: false,
    success: false,
    error: '',
    codeSuccess: false,
    loadingCodeInfo: true,
    loading: false,
    errorMessages: {
      invalid_email_password: 'Ogiltlig e-post eller lösenord har angivits, försök igen!'
    }
  }),
  methods: {
    // restore
    //
    //
    async restore () {
      this.loading = true

      const response = await fetch('https://api.systemnexa2.se/1/account/password/restore', {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          password: this.password,
          code: this.$route.params.code
        })
      })

      const json = await response.json()

      this.loading = false
      this.restored = true
      this.success = json.success
      this.error = json.message
      if (this.error.length) {
        this.password = ''
        this.password2 = ''
      }

      if (!this.success) {
        setTimeout(() => {
          this.restored = false
          this.success = false
          this.error = ''
        }, 4000)
      }
      
      console.log(json)
    }
  },
  computed: {
    ok () {
      return this.password.length >= 6 && (this.password === this.password2) && !this.loading
    }
  }
}
</script>
